import React, { useEffect, useState } from 'react';
import { ImageEntity, GlobalImage } from '../../../../global';
import { Col, Row } from 'antd';
import styles from './LayoutBlockSideBySideImages.module.scss';
import { rowThumbnailProps } from 'src/utils/grid';
import { ChannelsFullNames } from 'src/modules/locale';

export interface LayoutBlockSideBySideImagesProps {
  image1: ImageEntity;
  image2: ImageEntity;
  channel?: ChannelsFullNames;
}

const LayoutBlockSideBySideImages: React.FunctionComponent<LayoutBlockSideBySideImagesProps> = (
  props: LayoutBlockSideBySideImagesProps
) => {
  const { image1, image2 } = props;

  const [hack, setHack] = useState('');

  useEffect(() => {
    setHack('hack');
  }, []);

  // Note: the image props that come from dynamic zone have a different shape
  // (it's not ImageEntity)
  const ratio = (image1?.image as any)?.width > (image1?.image as any)?.height ? 3 / 2 : 3 / 4;

  return (
    <div className={styles.container} key={`layoutblock-sidebyside-${hack}`}>
      <Row {...rowThumbnailProps}>
        <Col xs={24} sm={24} md={{ span: 10, offset: 2 }} lg={{ span: 10, offset: 2 }}>
          <GlobalImage
            key={1}
            {...image1?.image}
            caption={image1?.caption}
            products={image1?.products}
            captionSize="small"
            ratio={ratio}
          />
        </Col>
        <Col xs={24} sm={24} md={{ span: 10 }} lg={{ span: 10 }}>
          <GlobalImage
            key={2}
            {...image2?.image}
            caption={image2?.caption}
            products={image2?.products}
            captionSize="small"
            ratio={ratio}
          />
        </Col>
      </Row>
    </div>
  );
};

export default LayoutBlockSideBySideImages;
